import { render, staticRenderFns } from "./Func51Historico.vue?vue&type=template&id=2292bae5"
import script from "./Func51Historico.vue?vue&type=script&lang=js"
export * from "./Func51Historico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports